<template>
  <FiltersItem>
    <template #title>
      {{ $l('showresult.filter.priceTitle') }}
    </template>
    <template #content>
      <!-- Price range -->
      <FiltersItemPriceRange v-if="resultsQueryStore?.state?.response?.uniquePrices?.length" />

      <!-- Payment method -->
      <FiltersItemPaymentMethod v-if="resultsQueryStore?.state?.response?.uniquePaymentMethods?.length" />

      <!-- Youth ticket -->
      <FiltersItemContent>
        <template #content>
          <FiltersList
            v-if="products.length"
            :items="products"
            class="filtersList--price"
            :show-exclusive="false"
            @itemClicked="productToggle"
          />
        </template>
      </FiltersItemContent>
    </template>

    <template #summary>
      <FiltersItemSummary :items="summaryItems" />
    </template>
  </FiltersItem>
</template>

<script setup>
import { l, lc, lreplace } from '@utils/toolbox';

import { useFiltersStore } from './store/filtersStore';
import { useResultQueryStore } from './store/resultQueryStore';
import FiltersItemContent from './FiltersItemContent.vue';

const filtersStore = useFiltersStore();
const resultsQueryStore = useResultQueryStore();

const summaryItems = computed(() => {
	const summary = [];

	// Price
	if (filtersStore.state.price) {
		const price = lreplace('showresult.filter.summary.totalPrice', { lc: lc(filtersStore.state.price) });
		summary.push(price);
	}

	if (filtersStore.state.paymentMethodIncluded) {
		const cardType = js_params.module.Filters.paymentMethodsAll[filtersStore.state.paymentMethodIncluded];
		summary.push(lreplace('showresult.filter.summary.paymentWith', { card: cardType }));
	}

	return summary;
});

const products = computed(() => {
	if (js_params?.isYouthSearch) {
		return [
			{
				text: l('showresult.filter.youthTicket'),
				value: 1,
				key: 'youthTicket',
				tooltipText: 'showresult.filter.youthTicket.tooltip',
				tooltipIcon: 'info',
				isChecked: filtersStore.state.youthTicket,
				enabledValue: true,
				disabled: !resultsQueryStore.state.response?.meta?.hasYouthTickets
			}
		];
	}
	return [];
});

async function productToggle (event) {
	const { key } = event;
	const item = products.value.find(i => i.key === key);
	const value = filtersStore.state[key] ? null : item.enabledValue;
	await filtersStore.set({ key, value });
}

</script>


<style scoped lang="scss">
:deep(.filtersList .icon-with-tooltip) {
	align-self: center;
	top: 0px;
}
</style>
